/**
 * 
 * @copyright     (c) 2024-2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/_components/RadioButtonsMega/_components/RadioButtonMega.js
 * Created:       Mon May 06 2024
 * Modified By:   Greg Olive
 * Last Modified: Tue Apr 22 2025
 */

import React from "react";
import {getImage} from "../../../../_utils";

export default function RadioButtonMega({
  id,
  groupName,
  name,
  option,
  onChange,
  value,
}) {

  const checked = (option.value + "") === (value + "");

  return (
    <div className={`gc__mega-radio-button-wrapper ${groupName}--radio-wrapper`}>
      <input
        type="radio"
        id={`${groupName}_${id}`}
        name={name}
        value={option.value}
        onChange={onChange}
        checked={checked}
        className={`${groupName}--radio-input`}
      />
      <label
        htmlFor={`${groupName}_${id}`}
        className={`${groupName}--radio-label`}
      >
        <span className={`gc__mega-radio-image-wrapper ${groupName}--radio-image-wrapper`}>
          <img 
            src={getImage(option.icon)}
            alt=""
            className={`${groupName}--radio-icon`}
          />
        </span>
        <span className={`gc__mega-radio-text-wrapper ${groupName}--radio-text-wrapper`}>
          <span className={`gc__mega-radio-title ${groupName}--radio-title`}>
            {option.label}
          </span>
          <span className={`gc__mega-radio-help ${groupName}--radio-help`}>
            {option.help}
          </span>
        </span>
      </label>
    </div>
  );
};
